export const safeParseJSON = (value) => {
  try {
    return JSON.parse(value)
  } catch (err) {
    return null
  }
}


// WEBPACK FOOTER //
// ./src/utils/func.js